<template>
  <section class="my-8 md:my-12">
    <div class="px-8 md:px-12 lg:px-16 xl:px-24">
      <div class="page-container">
        <h3>Related articles</h3>
        <div class="flex flex-col md:flex-row flex-wrap gap-[3%]">
          <div v-for="resource in relatedPosts" class="w-full md:w-[calc(33.333%_-_2%)]">
            <ResourceCard :resource="resource"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { getPostsQuery } from "~/graphql/queries/getPosts";
  import ResourceCard from "~/components/pages/blocks/Resources/ResourceCard.vue";

  const props = defineProps(['postId', 'categories']);

  const relatedPosts = ref([]);

  const query = getPostsQuery(3, false, props.categories[0].node.categoryId, '', [props.postId]);

  const { data } = await useAsyncQuery(query);

  if (data.value?.posts?.edges) {
    relatedPosts.value = data.value?.posts?.edges.map((item: any) => {
      return item.node;
    });
  }
</script>

<style scoped>

</style>
